import * as React from "react";
import { FormControl, FormHelperText, MenuItem, Select } from "../widget";
import { RxFormField } from "../../rx-form";
import { isDefined, isEmpty } from "../../utils";
import KeyValuePair from "../../utils/KeyValuePair";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';


const styles = (theme: Theme) => createStyles({
    select: {
        '&:focus': {
            background: 'rgba(0,0,0,0)'
        }
    },
    placeholder: {
        opacity: 0.45,
        '&:focus': {
            background: 'rgba(0,0,0,0)'
        }
    },
});


export interface ComboBoxSelectionItemsProps {
    items: KeyValuePair<number | string, string>[];
}

export const selectInputItems = (items: KeyValuePair<number | string, React.ReactNode>[]) => {
    return items.map((i: KeyValuePair<number | string, React.ReactNode>) => <MenuItem key={i.key} value={i.key}>{i.value}</MenuItem>);
}

export interface ComboBoxSelectionProps extends RxFormField {
    autoFocus?: boolean;
    fullWidth?: boolean;
    items?: KeyValuePair<number | string, string>[];
}

class ComboBoxSelection extends React.PureComponent<ComboBoxSelectionProps & WithStyles<typeof styles>> {

    render() {

        const { items, fullWidth, autoFocus, classes, ...field } = this.props;
        const helperTextId = (field.note || field.error) ? `${field.id}-text` : undefined;
        const hasError = field.touched && isDefined(field.error);
        const helperText = hasError ? field.error : field.note;
        const value = isEmpty(field.value) ? field.placeholder || '' : field.value;
        const renderValue = isEmpty(field.value) ? (() => field.placeholder || '') : undefined;
        const selectClass = isEmpty(field.value) ? classes.placeholder : classes.select;

        return <FormControl fullWidth={fullWidth} error={hasError} aria-describedby={helperTextId}>
            <Select fullWidth autoFocus={autoFocus} classes={{ select: selectClass }} renderValue={renderValue} name={field.name} id={field.id} value={value} onChange={field.onChange} onBlur={field.onBlur}>
                {items ? selectInputItems(items) : this.props.children}
            </Select>
            {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
        </FormControl>;
    }
}

export default withStyles(styles)(ComboBoxSelection);
